import React from 'react';
import { useSmartWelcomeHook } from './hooks';
import { Container as StyledContainer } from '../styles/welcomeStyles';
import SmartWelcome from './SmartWelcome';
import LoaderBlock from './LoaderBlock';
import SmartWelcomeRebrand from './SmartWelcomeRebrand';
import { Loader } from '@clientos/ui-toolkit';
import FontLoader from '../FontLoader';
import EnableHpAIForPrint from './EnableHpAIForPrint';
import ThemeProvider from '../components/ThemeProvider';
import { APP_NAME } from '../constants/queryParams';
import PSAGeneralConsent from './PSAGeneralConsent';
import EasyStartModifyConsent from './EasyStartModifyConsent';

const WelcomeContainer = ({ printerWelcome, reTarget, consentsUpdate, currentStack }) => {
  const printerWelcomeProps = useSmartWelcomeHook({
    printerWelcome,
    reTarget,
    consentsUpdate,
    currentStack
  });

  const { noContent, query } = printerWelcomeProps;
  const smartWelcomeProps = { ...printerWelcomeProps, reTarget };

  const isHPX = query?.brand === 'hpx';
  const queryAppName = (query.appName || '').toLowerCase();

  const hasPSAConsent = queryAppName === (APP_NAME.PSA_AI_CONSENTS || '').toLowerCase();
  const hasPSAGenConsent = queryAppName === (APP_NAME.PSA_GEN_CONSENT || '').toLowerCase();
  const hasEasyStartModifyConsent = queryAppName === (APP_NAME.EASY_START_MODIFY_CONSENT || '').toLowerCase();

  if (noContent) {
    return (
      <StyledContainer data-testid="no-content">
        {isHPX ? <Loader type="circular" /> : <LoaderBlock />}
      </StyledContainer>
    );
  }

  let psaConsentComponent = null;
  if (hasPSAConsent) {
    psaConsentComponent = (
      <EnableHpAIForPrint data-testid="welcome-container" {...smartWelcomeProps} />
    );
  } else if (hasPSAGenConsent) {
    psaConsentComponent = (
      <PSAGeneralConsent data-testid="welcome-container" {...smartWelcomeProps} />
    );
  }

  if (hasEasyStartModifyConsent) {
    return (
      <ThemeProvider>
        <FontLoader>
          <EasyStartModifyConsent data-testid="welcome-container" {...smartWelcomeProps} />
        </FontLoader>
      </ThemeProvider>
    );
  }

  if (isHPX) {
    return (
      <FontLoader>
        <SmartWelcomeRebrand data-testid="welcome-container" {...smartWelcomeProps} />
      </FontLoader>
    );
  }

  if (hasPSAConsent || hasPSAGenConsent) {
    return (
      <ThemeProvider>
        <FontLoader>
          {psaConsentComponent}
        </FontLoader>
      </ThemeProvider>
    );
  }

  return (
    <SmartWelcome data-testid="welcome-container" {...smartWelcomeProps} />
  );
};

export default WelcomeContainer;